import { COOKIES_DOMAIN } from "./settings";

export function getCookie(name: string): string {
  const decodedCookies = decodeURIComponent(document.cookie);
  const cookies = decodedCookies.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];

    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }

    const cookieName = name + "=";

    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }

  return "";
}

export function setCookie(
  name: string,
  value: any,
  path: string,
  expires?: Date
): void {
  const domain = COOKIES_DOMAIN;
  document.cookie = `${name}=${encodeURIComponent(
    value
  )};path=${path};expires=${expires};domain=${domain}`;
}

export function deleteCookie(name: string, path: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
}
